import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { ToastService } from '@shared/services/toast.service';
import { createNextStep, createNextStepFailure, createNextStepSuccess } from '../actions/create-next-step.actions';
import { NextStep } from '@shared/models/next-step';
import { NextStepsApiService } from '@core/services/next-steps-api.service';

@Injectable()
export class CreateNextStepEffects {
  constructor(
    private actions$: Actions,
    private nextStepsApiService: NextStepsApiService,
    private toastService: ToastService,
  ) {}

  createNextStep$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createNextStep),
      switchMap((action) => {
        return this.nextStepsApiService.create(action.nextStep).pipe(
          map((response: { data: NextStep }) => {
            return createNextStepSuccess({ nextStep: response.data });
          }),
          catchError((error) => {
            return of(createNextStepFailure({ error }));
          }),
        );
      }),
    ),
  );

  createNextStepSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createNextStepSuccess),
        tap(() => {
          this.toastService.showToast('success', 'Successfully created next step.', 3000);
        }),
      ),
    { dispatch: false },
  );

  createNextStepFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createNextStepFailure),
        tap(({ error }) => {
          const errorMessage =
            typeof error.error?.errors === 'string'
              ? error.error.errors
              : 'Failed to create next step. Please try again later.';
          this.toastService.showToast('error', errorMessage, 10000);
        }),
      ),
    { dispatch: false },
  );
}
